export const APARTMENTS_CONFIG = {
  facility: {
    key: "facility",
    label: "Inmueble"
  },
  phone: {
    key: "phone",
    label: "Telefono"
  },
  customer: {
    key: "customer",
    label: "Cliente"
  },
  address: {
    key: "address",
    label: "Domicilio"
  },
  apartmentNumber: {
    key: "number",
    label: "Numero de Departamento"
  },
  buildingTower: {
    key: "tower",
    label: "Edificio o Torre"
  },
  floor: {
    key: "flat",
    label: "Piso"
  },
  releaseDate: {
    key: "registrationDate",
    label: "Fecha de alta"
  },
  sector: {
    key: "business",
    label: "Giro"
  },
  status: {
    key: "status",
    label: "Estatus"
  },
  contract: {
    key: "contract",
    label: "Contrato"
  },
  meter: {
    key: "meter",
    label: "Medidor"
  }
};

export const APARTMENTS_PHRASE = {
  page: {
    table: {
      title: "Catalogo de Departamento"
    }
  },
  modal: {
    titles: {
      edit: "Modificar Departamento",
      add: "Agregar Nuevo Departamento",
      delete: "¿Estas seguro de eliminar este departamento?",
      serviceOff: "¿Estas seguro que deseas cortar el servicio?",
      serviceOn: "¿Estas seguro que deseas reconectar el servicio?"
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
      serviceOff: "Desconectar Servicio",
      serviceOn: "Conectar Servicio"
    },
    responses: {
      status: "Se actualizó el estatus del apartamento"
    }
  },
  meterModal: {
    title: "Asignar Medidor",
    actions: {
      cancel: "Cancelar",
      assign: "Asignar"
    }
  },
  customerModal: {
    title: "Asignar Cliente",
    actions: {
      cancel: "Cancelar",
      assign: "Asignar"
    }
  },
  contractModal: {
    title: "Asignar Contrato",
    actions: {
      cancel: "Cancelar",
      assign: "Asignar"
    }
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta."
    }
  },
  form: {
    dropdowns: {
      facility: "Seleccione un Inmueble",
      customer: "Seleccione un Cliente",
      address: "Seleccione una Direccion",
      sector: "Seleccione un Giro",
      status: "Seleccione un Estatus",
      meter: "Seleccione un Medidor"
    }
  }
};
